import { useCallback, useState } from 'react'

export type RequestState = { status: 'idle' } | { status: 'sending' } | { status: 'done' } | { status: 'failed'; error: Error }

export interface AccountRequest {
  readonly state: RequestState
  readonly run: (request: () => Promise<void>) => Promise<void>
}

/** Tracks one account-service call made from a form submit or a button. */
export function useAccountRequest(): AccountRequest {
  const [state, setState] = useState<RequestState>({ status: 'idle' })
  const run = useCallback(async (request: () => Promise<void>): Promise<void> => {
    setState({ status: 'sending' })
    try {
      await request()
      setState({ status: 'done' })
    } catch (error) {
      setState({ status: 'failed', error: error as Error })
    }
  }, [])
  return { state, run }
}
